import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/lib/motion";
import { SERVICES } from "@/data/site";

// Bento spans to break symmetry across the 13 services
const SPANS = {
  0: "md:col-span-2",
  3: "lg:col-span-2",
  7: "md:col-span-2",
  12: "md:col-span-2 lg:col-span-2",
};

const Card = ({ s, i }) => {
  const Icon = s.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (i % 4) * 0.05, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative overflow-hidden rounded-2xl border border-border bg-card shadow-sm p-6 md:p-7 hover:border-primary/50 transition-colors ${SPANS[i] || ""}`}
      data-testid={`service-card-${i}`}
    >
      <div className="absolute -right-16 -top-16 w-40 h-40 rounded-full bg-primary/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <div className="relative flex items-start justify-between">
        <span className="grid place-items-center w-12 h-12 rounded-xl bg-primary/15 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
          <Icon className="w-6 h-6" />
        </span>
        <ArrowUpRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-all group-hover:rotate-45" />
      </div>
      <h3 className="relative mt-6 text-xl font-heading font-semibold tracking-tight">{s.title}</h3>
      <p className="relative mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
    </motion.div>
  );
};

export const ServicesGrid = ({ heading = true }) => {
  return (
    <section id="services" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        {heading && (
          <div className="max-w-2xl mb-14">
            <Reveal as="p" className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Services</Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 text-4xl md:text-5xl font-heading font-bold tracking-tight">
                Everything you need to grow online
              </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-4 text-muted-foreground text-lg">
              From premium websites to AI automation and paid ads — one team, one point of accountability, faster results.
            </Reveal>
          </div>
        )}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 auto-rows-fr">
          {SERVICES.map((s, i) => <Card key={s.title} s={s} i={i} />)}
        </div>
        {heading && (
          <Reveal delay={0.1} className="mt-10">
            <Link to="/services" data-testid="services-view-all" className="inline-flex items-center gap-2 rounded-full border border-border hover:border-primary hover:text-primary font-semibold px-6 py-3 transition-colors">
              View all services <ArrowUpRight className="w-4 h-4" />
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
};
